import React from "react";
import { component_tool } from "@/tool";
import './index.less'
const { WizDropdown, WizMenu, WizIcon, WizTooltip, WizInputNumber } = component_tool;

export default function (activeKey, dataItems, item,) {
  const menu = (record, pIndex) => (
    <WizMenu>
      <WizMenu.Item onClick={() => this.handleSelectConditionType(record, 0, pIndex)}>与</WizMenu.Item>
      <WizMenu.Item onClick={() => this.handleSelectConditionType(record, 1, pIndex)}>或</WizMenu.Item>
    </WizMenu>
  );
  const valueMenu = (record, pIndex) => (
    <WizMenu>
      <WizMenu.Item onClick={() => this.handleSelectPassThrough(record, 0, pIndex)}>未通过</WizMenu.Item>
      <WizMenu.Item onClick={() => this.handleSelectPassThrough(record, 1, pIndex)}>通过</WizMenu.Item>
    </WizMenu>
  );
  const formatName = () => {
    let desc = ''
    if (item == 0) {
      desc = '课程名称'
    } else if (item == 1) {
      desc = '考试名称'
    } else if (item == 8) {
      desc = '主题名称'
    } else if (item == 30) {
      desc = '作业名称'
    } else if (item == 12) {
      desc = '路径名称'
    }
    return desc
  }

  return [
    {
      title: formatName(),
      name: 'conditionBizName',
      tableItem: {
        render: (text, record, index) => record.trainPathName ? `${record.trainPathName}->${record.conditionBizName}` : text
      }
    },
    {
      title: '条件',
      name: 'conditionType',
      tableItem: {
        width: 150,
        render: (text, record, index) => {
          return (<div className="and-or-box">
            <div>通过状态</div>
            {index==0 ?
              null :
              <div className="and-or">
                <WizDropdown overlay={menu(record, record.pIndex)}><a> {text === 0 ? '与' : '或'} <WizIcon type='down' /></a></WizDropdown>
              </div>}
          </div>)
        }
      }
    },
    {
      title: '值',
      name: 'conditionActionType',
      tableItem: {
        width: 150,
        render: (text, record, index) => {
          if(index==0){
            console.log(text,'第一个text')

          }
          return(<WizDropdown overlay={valueMenu(record, record.pIndex)}><span className="label-update-check-allow"> {text === 0 ? '未通过' : '通过'} <WizIcon type='down' /></span></WizDropdown>)
        }
      }
    },
    {
      title: '状态',
      name: '',
      tableItem: {
        width: 150,
        render: (text, record, index) => {
          return (
            <span>已发布</span>
          )
        }
      },

    },
    {
      title: '操作',
      name: 'oprate',
      tableItem: {
        width: 200,
        render: (text, record, index) =>

          <React.Fragment>
            <div className="label-update-delete-box">
              <a onClick={() => this.getItemAuth(record)} className="delete-btn">查看受众</a>
              <a onClick={() => this.handleDelete(record)} className="delete-btn">删除</a>
            </div>
          </React.Fragment>

      }
    },
  ]
}
